<template lang="pug">
.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            ref='tableLaudos',
            :data='tableData',
            :row-key='getRowKey',
            @sort-change='sortChangeRequest',
            @selection-change='alterarLaudosSelecionados'
        )
            el-table-column(
                align='center',
                type='selection',
                :reserve-selection='true',
                :selectable='canSelectRow'
            )
            el-table-column(
                v-if='showAnalystColumns',
                width='50',
                prop='id',
                label='ID',
                align='left'
            )
            el-table-column(
                prop='codigo',
                :label='$t("mensagens.laudos.gridColunaHash")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.codigo') {{ scope.row.codigo }}
            el-table-column(
                prop='informacaoLaudo.nomeTerritorio',
                :label='$t("mensagens.laudos.territorio")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(
                        v-if='scope.row.informacaoLaudo && scope.row.informacaoLaudo.nomeTerritorio != null',
                        :title='scope.row.informacaoLaudo.nomeTerritorio'
                    ) {{ scope.row.informacaoLaudo.nomeTerritorio }}
                    span(v-else) --
            el-table-column(
                prop='informacaoLaudo.car.codigo',
                :label='$t("mensagens.laudos.car")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(
                        :title='scope.row.informacaoLaudo.car.codigo'
                    ) {{ scope.row.informacaoLaudo.car.codigo }}
            el-table-column(
                prop='ano',
                :label='$t("mensagens.laudos.anoCertificacao")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    div(
                        v-if='scope.row.anoRenovabio'
                    )
                        span {{ scope.row.anoRenovabio }}
                    div(v-else)
                        span --
            el-table-column(
                prop='dataCadastroFormatado',
                :label='$t("mensagens.laudos.dataSolicitacao")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label='$t("mensagens.laudos.dataEntrega")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='situacao',
                width='200px',
                :label='$t("mensagens.laudos.situacao")',
                sortable
            )
                .template(slot-scope='scope')
                    LabelSituacao(
                        :tipo='tipoLabel',
                        :codigo='scope.row.situacao.codigo'
                    )
            el-table-column(
                prop='elegivelRenovabio',
                :label='$t("mensagens.laudos.renovabioNome")',
                sortable
            )
                .template(slot-scope='scope')
                    LabelRenovabio(
                        :tipo='tipoLabel',
                        :elegivel='scope.row.elegivelRenovabio'
                    )

            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioAnaliseNome',
                :label='$t("mensagens.laudos.analistaResponsavel")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.usuarioAnaliseNome') {{ scope.row.usuarioAnaliseNome }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioSolicitacaoNome',
                :label='$t("mensagens.comuns.solicitante")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.usuarioSolicitacaoNome') {{ scope.row.usuarioSolicitacaoNome }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='nomeEmpresa',
                :label='$t("mensagens.laudos.empresa")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span.truncate(:title='scope.row.nomeEmpresa') {{ scope.row.nomeEmpresa }}

            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                align='left'
            )
                .template.d-flex.justify-content-left(slot-scope='scope')
                    el-dropdown.action-button(trigger='click', :disabled='!hasDropdownItems(scope)')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "PROCESSADO" ',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.baixarLaudo') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "PROCESSADO" ',
                                icon='el-icon-document',
                                @click.native='solicitarConfirmacaoLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.solicitarConfirmacao') }}
                            el-dropdown-item(
                                v-if='scope.row.situacao.codigo === "NA_FILA"  && !showAnalystColumns'
                                icon='el-icon-circle-close',
                                @click.native='showModalCancelarLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.cancelarLaudo') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo !== "CANCELADO" && showAnalystColumns',
                                icon='el-icon-download',
                                @click.native='baixarDados(scope.row.id)'
                            ) {{ $t('mensagens.laudos.baixarDados') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo !== "CANCELADO" && showAnalystColumns',
                                icon='el-icon-upload',
                                @click.native='abreModalInserirResultado(scope.row)',
                                :disabled='scope.row.situacao.codigo === "PROCESSADO"'
                            ) {{ $t('mensagens.laudos.inserirResultado') }}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo === "CANCELADO" && showAnalystColumns',
                                icon='el-icon-minus'
                            ) {{ $t('mensagens.laudos.nenhumaAcao') }}

    EmptyResultLaudo(
        v-else,
        :semLaudoSelecionado='false',
        :p1='$t("mensagens.comuns.semDados")',
        :p2='$t("mensagens.laudos.naoConseguimosLocalizarNenhumLaudo")'
    )
</template>

<script>
import LaudosService from '@/services/LaudosService';
import UtilsService from '@/services/UtilsService';
import LabelTipo from '@/constants/LabelTipo';
import LabelSituacao from '@/components/labels/LabelLaudoSituacao.vue';
import LabelRenovabio from '@/components/labels/LabelLaudoRenovabio.vue';
import EventBus from '@/utils/eventBus';
import EmptyResultLaudo from '@/components/laudos/EmptyResultLaudo.vue';
import { mapState } from 'vuex';

export default {
    name: 'LaudoListagemAnalista',
    components: {
        EmptyResultLaudo,
        LabelSituacao,
        LabelRenovabio
    },
    props: {
        tableData: {
            type: Array,
            required: true
        },
        showAnalystColumns: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            idKeycloak: '',
            tipoLabel: LabelTipo.BARRA
        };
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    created() {
        this.idKeycloak = this.usuarioLogado.idKeyCloack;
    },
    mounted() {
        EventBus.$off('laudos:limpar-selecao');
        EventBus.$on('laudos:limpar-selecao', () => {
            this.$refs.tableLaudos.clearSelection();
        });

        EventBus.$off('laudos:marcar-todos');
        EventBus.$on('laudos:marcar-todos', () => {
            this.$refs.tableLaudos.toggleAllSelection();
        });
    },
    methods: {
        hasDropdownItems(scope) {
            const situacaoCodigo = scope.row?.situacao?.codigo;
            const isAnalyst = this.showAnalystColumns;

            return (
                situacaoCodigo === 'PROCESSADO' ||
                situacaoCodigo === 'NA_FILA' ||
                (isAnalyst && situacaoCodigo !== 'CANCELADO')
            );
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }
            if (prop === 'dataFinalizacaoFormatado') {
                prop = 'dataFinalizacao';
            }

            let params = {
                order: null,
                column: prop
            };

            if (column.order === 'ascending') {
                params.order = 'ASC';
            } else if (column.order === 'descending') {
                params.order = 'DESC';
            }

            this.$emit('handleSort', params);
        },
        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.laudos.downloadRealizadoComSucesso'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.erroAoRealizarDownload'
                        )
                    });
                });
        },
        solicitarConfirmacaoLaudo(laudo) {
            LaudosService.solicitarConfirmacaoLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.laudos.enviadoParaConfirmacao'
                        )
                    });
                    this.atualizarTabela();
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.erroAoEnviarLaudoParaConfirmacao'
                        )
                    });
                });
        },
        showModalCancelarLaudo(row) {
            this.$store.dispatch('processarEventoGoogleAnalytics', {
                eventLabel: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                pageTitle: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                routeName: this.$route?.name,
                routePath: this.$route?.path
            });
            this.$emit('handleModalCancelamento', row.id);
        },
        getRowKey(row) {
            return row.id;
        },
        canSelectRow(row, index) {
            return row.situacao.codigo === 'PROCESSADO';
        },
        alterarLaudosSelecionados(laudosSelecionados) {
            EventBus.$emit(
                'laudos:setar-lista-laudos-download-em-lote',
                laudosSelecionados
            );
            if (laudosSelecionados.length === 0) {
                EventBus.$emit(
                    'laudos:setar-lista-laudos-download-em-lote',
                    []
                );
            }
            EventBus.$emit('laudos:resetar-selecionar-todos');
        },
        abreModalInserirResultado(row) {
            this.$emit('handleModalInsercaoResultados', row);
        },
        async baixarDados(idLaudo) {
            try {
                await this.atualizaStatus(idLaudo);
                await UtilsService.baixarArquivo(
                    `/laudo/${idLaudo}/shape/${this.idKeycloak}`
                );
            } catch (error) {
            } finally {
                this.atualizarTabela();
            }
        },
        async atualizaStatus(idLaudo) {
            try {
                await LaudosService.atualizarStatusLaudo({
                    id: idLaudo
                });
            } catch (e) {}
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        }
    }
};
</script>

<style lang="scss" scoped>
.el-table {
    .cell {
        .truncate {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: default;
        }
    }

    .action-button {
        cursor: pointer;
    }
}

.indicador {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: inline-block;
    margin: 0 auto;
    max-width: 150px;
}

.conforme {
    background-color: #d5f8d7;
    border: 1px solid #b0dcb3;
}

.nao-conforme {
    background-color: #f7d6da;
    border: 1px solid #e58585;
}

.inconclusivo {
    background-color: #f7e0bf;
    border: 1px solid #e5b385;
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
    display: flex;
    align-items: center;
}
</style>
